angular.module('bmsApp.settings').controller('WorkingHoursCtrl', [
	'$scope',
	'$log',
	'$q',
	'AppSettingsSvc',
	'ConfigService',
	'notify',
	function (
		$scope,
		$log,
		$q,
		AppSettingsSvc,
		ConfigService,
		notify
	) {

		$scope.loaded = false;

		$scope.timepickerOpensConfig = angular.extend(angular.copy(ConfigService.config.uiTimepickerOptions), {
			minTime: '06:00',
		});
		$scope.timepickerClosesConfig = angular.extend(angular.copy(ConfigService.config.uiTimepickerOptions), {
			minTime: '12:00',
		});

		const loadBusinessHours = () => {
			let deferred = $q.defer();
			AppSettingsSvc.loadBusinessHours()
				.then((response) => {
					let businessHours = response.data.business_hours;
					// Convert time strings to moments
					angular.extend(businessHours, {
						mon_opens_at: businessHours.mon_opens_at ? moment(businessHours.mon_opens_at, 'HH:mm:ss') : null,
						mon_closes_at: businessHours.mon_closes_at ? moment(businessHours.mon_closes_at, 'HH:mm:ss') : null,
						tue_opens_at: businessHours.tue_opens_at ? moment(businessHours.tue_opens_at, 'HH:mm:ss') : null,
						tue_closes_at: businessHours.tue_closes_at ? moment(businessHours.tue_closes_at, 'HH:mm:ss') : null,
						wed_opens_at: businessHours.wed_opens_at ? moment(businessHours.wed_opens_at, 'HH:mm:ss') : null,
						wed_closes_at: businessHours.wed_closes_at ? moment(businessHours.wed_closes_at, 'HH:mm:ss') : null,
						thu_opens_at: businessHours.thu_opens_at ? moment(businessHours.thu_opens_at, 'HH:mm:ss') : null,
						thu_closes_at: businessHours.thu_closes_at ? moment(businessHours.thu_closes_at, 'HH:mm:ss') : null,
						fri_opens_at: businessHours.fri_opens_at ? moment(businessHours.fri_opens_at, 'HH:mm:ss') : null,
						fri_closes_at: businessHours.fri_closes_at ? moment(businessHours.fri_closes_at, 'HH:mm:ss') : null,
						sat_opens_at: businessHours.sat_opens_at ? moment(businessHours.sat_opens_at, 'HH:mm:ss') : null,
						sat_closes_at: businessHours.sat_closes_at ? moment(businessHours.sat_closes_at, 'HH:mm:ss') : null,
						sun_opens_at: businessHours.sun_opens_at ? moment(businessHours.sun_opens_at, 'HH:mm:ss') : null,
						sun_closes_at: businessHours.sun_closes_at ? moment(businessHours.sun_closes_at, 'HH:mm:ss') : null,
					});
					$scope.businessHours = businessHours;
					deferred.resolve(true);
				}, (errors) => {
					$scope.errors = errors;
				});

			return deferred.promise;
		};

		$q.all({
			loadBusinessHours: loadBusinessHours(),
		})
			.then(() => {
				$scope.loaded = true;
			});

		$scope.submit = (form) => {
			if (form.$valid) {
				let saveDefer = $q.defer();
				$scope.processing = true;

				// Avoid timezone conversion by formatting as local time
				let data = {
					mon_opens_at: $scope.businessHours.mon_opens_at ? $scope.businessHours.mon_opens_at.format('HH:mm') : null,
					mon_closes_at: $scope.businessHours.mon_closes_at ? $scope.businessHours.mon_closes_at.format('HH:mm') : null,
					tue_opens_at: $scope.businessHours.tue_opens_at ? $scope.businessHours.tue_opens_at.format('HH:mm') : null,
					tue_closes_at: $scope.businessHours.tue_closes_at ? $scope.businessHours.tue_closes_at.format('HH:mm') : null,
					wed_opens_at: $scope.businessHours.wed_opens_at ? $scope.businessHours.wed_opens_at.format('HH:mm') : null,
					wed_closes_at: $scope.businessHours.wed_closes_at ? $scope.businessHours.wed_closes_at.format('HH:mm') : null,
					thu_opens_at: $scope.businessHours.thu_opens_at ? $scope.businessHours.thu_opens_at.format('HH:mm') : null,
					thu_closes_at: $scope.businessHours.thu_closes_at ? $scope.businessHours.thu_closes_at.format('HH:mm') : null,
					fri_opens_at: $scope.businessHours.fri_opens_at ? $scope.businessHours.fri_opens_at.format('HH:mm') : null,
					fri_closes_at: $scope.businessHours.fri_closes_at ? $scope.businessHours.fri_closes_at.format('HH:mm') : null,
					sat_opens_at: $scope.businessHours.sat_opens_at ? $scope.businessHours.sat_opens_at.format('HH:mm') : null,
					sat_closes_at: $scope.businessHours.sat_closes_at ? $scope.businessHours.sat_closes_at.format('HH:mm') : null,
					sun_opens_at: $scope.businessHours.sun_opens_at ? $scope.businessHours.sun_opens_at.format('HH:mm') : null,
					sun_closes_at: $scope.businessHours.sun_closes_at ? $scope.businessHours.sun_closes_at.format('HH:mm') : null,
				};

				AppSettingsSvc.saveBusinessHours(data)
					.then((response) => {
						notify({
							message: 'Business hours updated',
						});
						$q.all({
							loadBusinessHours: loadBusinessHours(),
						})
							.then(() => {
								saveDefer.resolve(true);
							}, (errors) => {
								$scope.errors = errors;
							});
					});
				$scope.savePromise = saveDefer.promise;

				return saveDefer.promise;
			}
		};

	}]);



